<template>
    <div v-if="loaded" class="nevs-content">
        <ModalAddCustomer :show="showAddCustomerModal" @done="addCustomerDone"></ModalAddCustomer>
        <ModalPayment :show="showPaymentModal" :invoice-id="invoice.id" :payment="editingPayment" @done="paymentDone"></ModalPayment>
        <ModalAssignInvoiceThings :show="assignThingsModal.show" :invoice-id="assignThingsModal.invoiceId"
                                  :entries="assignThingsModal.entries" :default-person-id="assignThingsModal.defaultPersonId"
                                  @done="assignThingsDone"></ModalAssignInvoiceThings>
        <div v-if="kpdPopup.show" class="nevs-popup-container">
            <div class="nevs-popup">
                <div class="nevs-popup-text">
                    <NevsSelect :nullable="true" :minimumSearchLength="3" v-model="kpdPopup.data.code_kpd" :ajax="'select/product-codes'"></NevsSelect>
                </div>
                <div class="nevs-popup-buttons">
                    <NevsButton class="error" @click="kpdPopup.cancel()"><i class="fa-solid fa-xmark"></i> {{
                            $LANG.Get('buttons.cancel')
                        }}
                    </NevsButton>
                    <NevsButton class="success" @click="kpdPopup.save()"><i class="fa-solid fa-check"></i> {{ $LANG.Get('buttons.ok') }}</NevsButton>
                </div>
            </div>
        </div>
        <div class="nevs-content-top-buttons">
            <NevsButton v-if="!imported" class="success" @click="saveClick()"><i class="fa-solid fa-floppy-disk"></i>
                {{ $LANG.Get('buttons.save') }}
            </NevsButton>&nbsp;
            <NevsButton class="error" @click="backClick"><i class="fa-solid fa-arrow-left"></i>
                {{ $LANG.Get('buttons.back') }}
            </NevsButton>
        </div>
        <NevsTabs class="invoice-tabs" :tabs="tabList" v-model="currentTab"></NevsTabs>
        <NevsTab :value="1" v-model="currentTab">
            <NevsCard class="form form-float">
                <NevsSelect v-model="invoice.customer_id" :ajax="'select/customers'"
                            :error="invoiceValidation.customer_id"
                            :label="$LANG.Get('fields.customer')"
                            :readonly="readonlyAll || readonlyVat"></NevsSelect>
                <div v-if="this.selectedCustomer !== null" class="customer-details">
                    {{ this.selectedCustomer.address }}<br/>
                    {{ this.selectedCustomer.postal_code }} {{ this.selectedCustomer.city }}<br/>
                    {{ this.selectedCustomer.country }}<br/>
                </div>
                <div class="f1-checkbox" v-if="showF1Checkbox">
                    <NevsCheckbox :label="$LANG.Get('fields.f1Enabled')" v-model="invoice.b2b_transaction_f1_enabled"></NevsCheckbox>
                </div>
                <div class="f1-notice" v-if="showF1Notice">
                    {{ $LANG.Get('labels.f1Notice') }}
                </div>
                <NevsButton v-if="!(readonlyAll || readonlyVat)" @click="showAddCustomerModal = true"><i class="fa-solid fa-plus"></i> 
                    {{ $LANG.Get('buttons.addNewCustomer') }}
                </NevsButton>
            </NevsCard>
            <NevsCard class="form form-float">
                <NevsDateField v-model="timeOfIssue.date" :error="timeOfIssueValidation.date"
                               :label="$LANG.Get('fields.dateOfIssue')"
                               :readonly="readonlyAll || readonlyVat || selectedSequenceIsFiskal"></NevsDateField>
                <NevsMaskedField v-model="timeOfIssue.time" :error="timeOfIssueValidation.time"
                                 :label="$LANG.Get('fields.timeOfIssue')"
                                 :mask="'NN:NN:NN'"
                                 :readonly="readonlyAll || readonlyVat || selectedSequenceIsFiskal"></NevsMaskedField>
                <NevsDateField v-model="invoice.due_date" :error="invoiceValidation.due_date"
                               :label="$LANG.Get('fields.dueDate')"
                               :readonly="readonlyAll || readonlyVat"></NevsDateField>
                <NevsDateField v-model="invoice.date_of_delivery" :error="invoiceValidation.date_of_delivery"
                               :label="$LANG.Get('fields.dateOfDelivery')"
                               :readonly="readonlyAll || readonlyVat"></NevsDateField>
            </NevsCard>
            <NevsCard class="form form-float">
                <NevsSelect v-if="showCurrency" v-model="invoice.currency" :ajax="currencyEndpoint"
                            :error="invoiceValidation.currency"
                            :label="$LANG.Get('fields.currency')"
                            :readonly="readonlyAll || currencyReadonly || readonlyVat"></NevsSelect>
                <NevsSelect :readonly="readonlyAll || invoice.cancels !== 0 || invoice.cancelled_by !== 0"
                            v-if="mode !== 'add' && mode !== 'copy'" v-model="invoice.invoice_status_id"
                            :ajax="'select/invoice-statuses'"
                            :error="invoiceValidation.invoice_status_id" :label="$LANG.Get('fields.status')"></NevsSelect>
                <NevsSelect v-if="mode !== 'edit'"
                            v-model="invoice.invoice_sequence_id"
                            :error="invoiceValidation.invoice_sequence_id"
                            :label="$LANG.Get('fields.sequence')" :options="sequences"
                                :readonly="readonlyAll || readonlyVat"></NevsSelect>
                <NevsSelect v-model="invoice.locale" :ajax="'select/languages'"
                            :error="invoiceValidation.locale" :label="$LANG.Get('fields.language')"
                            :readonly="readonlyAll"></NevsSelect>
                <NevsSelect v-model="invoice.payment_method_id" :ajax="'select/payment-methods'"
                            :error="invoiceValidation.payment_method_id" :label="$LANG.Get('fields.paymentMethod')"
                            :readonly="this.mode === 'edit'"></NevsSelect>
                <NevsSelect v-model="invoice.document_format_id" :ajax="'select/document-formats'" class="half"
                            :label="$LANG.Get('fields.documentFormat') + ':'"></NevsSelect>
            </NevsCard>
            <NevsCard class="items-card">
                <NevsSelect v-if="!(readonlyAll || readonlyVat)" v-model="selectedThing" :ajax="thingsEndpoint"
                            :error="invoiceValidation.items"
                            :label="$LANG.Get('labels.selectItem')" class="item-select"></NevsSelect>
                <NevsButton class="details-button" @click="toggleDetails()"><i class="fa-solid fa-eye"></i> {{ $LANG.Get('buttons.details') }}</NevsButton>
                <div class="items-container">
                    <table v-show="invoice.items.length !== 0" class="items-table">
                        <thead>
                        <tr class="items-table-header">
                            <td v-for="(header, key) in headers" :key="key" :style="{'width': header.width}">
                                {{ header.text }}
                            </td>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, key) in invoice.items" :key="key">
                            <td class="items-table-buttons">
                                <NevsButton v-show="!(readonlyAll || readonlyVat)" @click="removeItemClick(key)"><i class="fa-solid fa-trash"></i></NevsButton>
                            </td>
                            <td>
                                <NevsTextField v-model="item.description" :readonly="readonlyAll || item.product_id!==null"></NevsTextField><br />
                                <NevsTextArea v-if="showDetails" v-model="item.details" :readonly="readonlyAll"></NevsTextArea>
                            </td>
                            <td class="items-table-kpd">
                                <NevsButton v-show="!((readonlyAll || item.product_id!==null))" @click="changeKPDClick(key)"><i class="fa-solid fa-pen"></i></NevsButton>
                                {{ item.code_kpd }}
                            </td>
                            <td>
                                <NevsSelect v-model="item.measurement_unit_id" :ajax="'select/measurement-units'"
                                            :readonly="readonlyAll || item.product_id!==null"></NevsSelect>
                            </td>
                            <td>
                                <NevsNumberField v-model="item.price" :readonly="readonlyAll || readonlyVat"></NevsNumberField>
                            </td>
                            <td>
                                <NevsNumberField v-model="item.quantity" :decimal-places="3" :readonly="readonlyAll || readonlyVat"
                                                 :thousand-separator="''"></NevsNumberField>
                            </td>
                            <td v-if="invoice.tax_system && !invoice.ppo">
                                <NevsNumberField v-model="item.tax" :readonly="readonlyAll || readonlyVat"></NevsNumberField>
                            </td>
                            <td>
                                <NevsNumberField v-model="item.discount" :readonly="readonlyAll || readonlyVat"></NevsNumberField>
                            </td>
                            <td>
                                <NevsNumberField v-model="item.total" :readonly="true"></NevsNumberField>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <table v-show="invoice.items.length !== 0" class="summary-table">
                        <tbody>
                        <tr>
                            <td class="sub-table-left">{{ $LANG.Get('labels.additionalDiscount') }} (%):</td>
                            <td class="sub-table-right">
                                <NevsNumberField v-model="invoice.discount" :readonly="readonlyAll || readonlyVat"
                                                 :thousand-separator="''"></NevsNumberField>
                            </td>
                        </tr>
                        <tr v-for="(base, key) in taxBases" :key="key">
                            <td>
                                {{ $LANG.Get('labels.taxBase') }} {{ base.base }} ({{ invoice.currency }}):
                            </td>
                            <td>
                                <NevsNumberField v-model="base.value" :readonly="true"></NevsNumberField>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                {{ $LANG.Get('fields.total') }} ({{ invoice.currency }}):
                            </td>
                            <td>
                                <NevsNumberField v-model="total" :readonly="true"></NevsNumberField>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <div class="nevs-clear-float"></div>
                </div>
            </NevsCard>
            <NevsCard class="footer-container">
                <NevsTextArea v-model="invoice.footer" :error="invoiceValidation.footer"
                              :label="$LANG.Get('fields.footer')"
                              :readonly="readonlyAll"></NevsTextArea>
                <NevsCheckbox v-model="invoice.ppo" :label="$LANG.Get('fields.ppo')"
                              :readonly="readonlyAll || readonlyVat"></NevsCheckbox>
                <NevsTextField v-if="invoice.ppo" v-model="invoice.ppo_text"
                               :label="$LANG.Get('fields.ppoText')" :readonly="readonlyAll"></NevsTextField>
                <NevsSelect :minimumSearchLength v-if="!invoice.paid_by_advance_legacy" :label="$LANG.Get('fields.advanceInvoice')"
                            v-model="invoice.advance_invoice_id" :ajax="'select/invoices'" :width="'250px'" :nullable="true"></NevsSelect>
                <template v-if="invoice.paid_by_advance_legacy">
                    <NevsTextField v-model="invoice.advance_text"
                                   :label="$LANG.Get('fields.advanceText')" :readonly="true"></NevsTextField>
                    <NevsNumberField v-model="invoice.advance_amount"
                                     :label="$LANG.Get('fields.advanceAmount')"
                                     :readonly="true" :width="'200px'"></NevsNumberField>
                </template>
                <NevsSelect class="bank-field" v-if="ibanOptions.length > 1" :label="$LANG.Get('fields.iban')"
                            v-model="invoice.iban" :options="ibanOptions"></NevsSelect>
                <NevsSelect class="bank-field" v-if="swiftOptions.length > 1" :label="$LANG.Get('fields.swift')"
                            v-model="invoice.swift" :options="swiftOptions"></NevsSelect>
            </NevsCard>
        </NevsTab>
        <NevsTab :value="2" v-model="currentTab">
            <div class="payments-tab-disclaimer">{{ $LANG.Get('labels.paymentsTabDisclaimer') }}</div>
            <div class="nevs-content-top-buttons">
                <!-- Available on imported invoices too: the invoice itself cannot be edited, but it can still be
                     settled. Only the imported payments are locked, which is handled per row below. -->
                <NevsButton class="primary" @click="addPaymentClick()">
                    <i class="fa-solid fa-plus"></i>
                    {{ $LANG.Get('buttons.add') }}
                </NevsButton>
            </div>
            <NevsCard class="payments">
                <div v-if="invoice.payments.length === 0" class="payments-message">
                    {{ $LANG.Get('labels.noPayments') }}
                </div>
                <div v-if="invoice.payments.length > 0" class="payments-list">
                    <div v-for="(payment, key) in invoice.payments" :key="key" class="payment">
                        <table>
                            <tbody>
                            <tr>
                                <td class="payment-date">
                                    <span class="number-status-pill imported-pill" v-if="payment.imported" :title="$LANG.Get('labels.imported')">U</span>
                                    <NevsButton v-if="payment.disclaimer != ''" @click.stop="showDisclaimer(payment.disclaimer)" :title="payment.disclaimer" class="error invoice-disclaimer-button"><i class="fa-solid fa-triangle-exclamation"></i></NevsButton>
                                    {{ $HELPERS.FormatDate(payment.date) }}
                                    <span class="e-status-pill" v-if="payment.reported">EI</span>
                                </td>
                                <td class="payment-amount">{{ $HELPERS.FormatMoney(payment.amount) }} {{ payment.currency }}</td>
                                <td class="payment-actions">
                                    <NevsButton v-if="!payment.imported && payment.disclaimer != ''" :title="$LANG.Get('tooltips.eReporting')" @click="eReportingClick(payment)"><i class="fa-solid fa-globe"></i></NevsButton>
                                    <NevsButton v-if="!payment.imported" @click="editPaymentClick(payment)"><i class="fa-solid fa-pen"></i></NevsButton>
                                    <NevsButton v-if="!payment.imported" class="error" @click="deletePaymentClick(payment)"><i class="fa-solid fa-trash"></i></NevsButton>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </NevsCard>
        </NevsTab>
    </div>
</template>

<script>
import Invoice from '@/models/Invoice.js';
import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import Big from 'big.js';
import NevsSelect from "@/components/nevs/NevsSelect.vue";
import NevsDateField from "@/components/nevs/NevsDateField.vue";
import NevsMaskedField from "@/components/nevs/NevsMaskedField.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsNumberField from "@/components/nevs/NevsNumberField.vue";
import NevsTextArea from "@/components/nevs/NevsTextArea.vue";
import NevsCheckbox from "@/components/nevs/NevsCheckbox.vue";
import moment from "moment";
import ModalAddCustomer from "@/components/modals/ModalAddCustomer.vue";
import ModalPayment from "@/components/modals/ModalPayment.vue";
import ModalAssignInvoiceThings from "@/components/modals/ModalAssignInvoiceThings.vue";
import NevsTabs from "@/components/nevs/NevsTabs.vue";
import NevsTab from "@/components/nevs/NevsTab.vue";

export default {
    name: "EntityInvoice",
    components: {
        ModalAddCustomer,
        ModalPayment,
        ModalAssignInvoiceThings,
        NevsTabs,
        NevsTab,
        NevsCheckbox,
        NevsTextArea,
        NevsNumberField, NevsTextField, NevsMaskedField, NevsDateField, NevsSelect, NevsButton, NevsCard
    },
    data() {
        return {
            loaded: false,
            mode: this.$route.params.mode,
            invoice: new Invoice({
                id: parseInt(this.$route.params.id),
                iban: this.$store.state.user.client.iban[0],
                swift: this.$store.state.user.client.swift[0]
            }),
            invoiceValidation: new Invoice({}, true),
            selectedCustomer: null,
            selectedThing: null,
            assignThingsModal: {
                show: false,
                invoiceId: null,
                entries: [],
                defaultPersonId: null
            },
            taxBases: [],
            tempTaxBases: [],
            total: 0,
            currencyReadonly: false,
            originalCustomerId: null,
            // The due date last filled in from the client's defaults; a due date that differs from it was edited
            // by hand and is left alone when the customer changes.
            defaultDueDate: null,
            newCustomerData: null,
            customerChanged: false,
            timeOfIssue: {
                date: null,
                time: null
            },
            timeOfIssueValidation: {
                date: '',
                time: ''
            },
            sequences: [],
            readonlyAll: false,
            readonlyVat: false,
            imported: false,
            offerNumber: '',
            currentTab: 1,
            kpdPopup: {
                show: false,
                indexToEdit: null,
                data: {
                    code_kpd: ''
                },
                reset: () => {
                    this.kpdPopup.data = {
                        code_kpd: ''
                    };
                    this.kpdPopup.indexToEdit = null;
                },
                cancel: () => {
                    this.kpdPopup.show = false;
                },
                save: () => {
                    if (this.kpdPopup.data.code_kpd === null) this.kpdPopup.data.code_kpd = '';
                    this.invoice.items[this.kpdPopup.indexToEdit].code_kpd = this.kpdPopup.data.code_kpd;
                    this.kpdPopup.show = false;
                    this.kpdPopup.reset();
                }
            },
            selectedSequenceIsFiskal: false,
            showCurrency: false,
            currencyEndpoint: 'select/currencies',
            originalStatus: null,
            showAddCustomerModal: false,
            showDetails: false,
            showPaymentModal: false,
            editingPayment: null
        }
    },
    computed: {
        tabList() {
            return [
                {value: 1, label: this.$LANG.Get('buttons.generalData')},
                {value: 2, label: this.$LANG.Get('buttons.payments'), visible: this.mode === 'edit'}
            ];
        },
        showF1Checkbox() {
            return this.$store.state.user.client.e_invoices_token != ''
                && !this.$store.state.user.client.ignore_b2b_f1
                && (this.mode == 'add' || this.mode == 'copy')
                && this.$HELPERS.CheckF2(this, this.invoice.time_of_issue) == 1
                && this.selectedSequenceIsFiskal
                && this.selectedCustomer != null
                && this.selectedCustomer.company_id != null
                && this.invoice.payment_method_id == 1;
        },
        showF1Notice() {
            return this.$store.state.user.client.e_invoices_token != ''
                && !this.$store.state.user.client.ignore_b2b_f1
                && (this.mode == 'add' || this.mode == 'copy')
                && this.$HELPERS.CheckF2(this, this.invoice.time_of_issue) == 1
                && this.selectedSequenceIsFiskal
                && this.selectedCustomer != null
                && this.selectedCustomer.company_id != null
                && this.invoice.b2b_transaction_f1_enabled
                && this.invoice.payment_method_id == 1;
        },
        paymentCurrency() {
            if (this.invoice.currency === 'HRK' && this.paymentPopup.data.date + ' 00:00:00' >= this.$store.state.settings.EUR_TRANSITION) {
                return 'EUR';
            }
            return this.invoice.currency;
        },
        headers() {
            let headers = [
                {
                    text: '',
                    sortable: false,
                    value: 'actions',
                    width: '50px',
                    class: 'pa-0'
                },
                {
                    text: this.$LANG.Get('fields.description'),
                    sortable: false,
                    value: 'description',
                    class: 'pa-0 description-width'
                },
                {
                    text: this.$LANG.Get('fields.code_kpd'),
                    sortable: false,
                    value: 'kpd',
                    class: 'pa-0 description-width',
                    width: '120px'
                },
                {
                    text: this.$LANG.Get('fields.measurementUnit'),
                    sortable: false,
                    value: 'measurement_unit',
                    class: 'pa-0',
                    width: "100px"
                },
                {
                    text: this.$LANG.Get('fields.price') + ' (' + this.invoice.currency + ')',
                    sortable: false,
                    value: 'price',
                    class: 'pa-0',
                    width: "100px"
                },
                {
                    text: this.$LANG.Get('fields.quantity'),
                    sortable: false,
                    value: 'quantity',
                    class: 'pa-0',
                    width: "100px"
                },
                {
                    text: this.$LANG.Get('fields.discount'),
                    sortable: false,
                    value: 'discount',
                    class: 'pa-0',
                    width: "100px"
                },
                {
                    text: this.$LANG.Get('fields.total') + ' (' + this.invoice.currency + ')',
                    sortable: false,
                    value: 'total',
                    class: 'pa-0',
                    width: "100px"
                }
            ]
            if (this.invoice.tax_system && !this.invoice.ppo) {
                headers.splice(6, 0, {
                    text: this.$LANG.Get('fields.tax'),
                    sortable: false,
                    value: 'tax',
                    class: 'pa-0',
                    width: "100px"
                })
            }
            return headers;
        },
        ibanOptions() {
            let options = [];
            let current = this.invoice.iban;
            let currentExists = false;
            for (let iban of this.$store.state.user.client.iban) {
                if (iban === current) currentExists = true;
                options.push({
                    label: iban,
                    value: iban
                });
            }
            if (!currentExists) {
                options.push({
                    label: current,
                    value: current
                });
            }
            return options;
        },
        swiftOptions() {
            let options = [];
            let current = this.invoice.swift;
            let currentExists = false;
            for (let swift of this.$store.state.user.client.swift) {
                if (swift === current) currentExists = true;
                options.push({
                    label: swift,
                    value: swift
                });
            }
            if (!currentExists) {
                options.push({
                    label: current,
                    value: current
                });
            }
            return options;
        },
        thingsEndpoint() {
            return this.mode === 'edit' ? 'select/things-no-wares' : 'select/things';
        }
    },
    watch: {
        'invoice.payment_method_id': function () {
            if (this.loaded && this.mode !== 'edit') {
                this.setDocumentFormatFromPaymentMethod();
            }
        },
        'invoice.locale': function () {
            if (this.loaded) {
                let vm = this;
                for (let i = 0; i < this.invoice.items.length; i++) {
                    let item = this.invoice.items[i];
                    if (item.product_id !== null) {
                        this.$API.APICall('get', 'products/' + item.product_id, {}, (data, success) => {
                            if (success) {
                                let newName = (data.product['name_' + vm.invoice.locale] !== undefined) ? data.product['name_' + vm.invoice.locale] : data.product.name;
                                if (newName != '') vm.invoice.items[i].description = newName;
                            }
                        }, false);
                    } else if (item.membership_id !== undefined && item.membership_id !== null) {
                        this.$API.APICall('get', 'memberships/' + item.membership_id, {}, (data, success) => {
                            if (success) {
                                let newName = (data.membership['name_' + vm.invoice.locale] !== undefined) ? data.membership['name_' + vm.invoice.locale] : data.membership.name;
                                if (newName != '') vm.invoice.items[i].description = newName;
                            }
                        }, false);
                    } else if (item.package_id !== undefined && item.package_id !== null) {
                        this.$API.APICall('get', 'packages/' + item.package_id, {}, (data, success) => {
                            if (success) {
                                let newName = (data.package['name_' + vm.invoice.locale] !== undefined) ? data.package['name_' + vm.invoice.locale] : data.package.name;
                                if (newName != '') vm.invoice.items[i].description = newName;
                            }
                        }, false);
                    }
                }
                this.invoice.footer = this.$store.state.user.client['invoice_footer_template_' + this.invoice.locale];
                this.invoice.ppo_text = this.invoice.ppo ? this.$store.state.user.client['ppo_template_' + this.invoice.locale] : '';
            }
        },
        'invoice.customer_id': function () {
            if (this.invoice.customer_id != null) {
                let vm = this;
                this.$API.APICall('get', 'customers/' + this.invoice.customer_id, {}, (data, success) => {
                    if (success) {
                        vm.selectedCustomer = data.customer;
                    }
                });
            } else {
                this.selectedCustomer = null;
            }
        },
        'selectedCustomer': function () {
            if (this.mode !== 'edit' && this.invoice.due_date === this.defaultDueDate) {
                this.setDefaultDueDate();
            }
        },
        'selectedThing': function () {
            if (this.selectedThing != null) {
                this.addItem();
            }
        },
        'invoice.items': {
            handler: function () {
                this.calculateTotals();
            },
            deep: true
        },
        'invoice.ppo': {
            handler: function () {
                this.calculateTotals();
                if (this.loaded) {
                    this.invoice.ppo_text = this.invoice.ppo ? this.$store.state.user.client['ppo_template_' + this.invoice.locale] : '';
                }
            },
            deep: true
        },
        'invoice.discount': {
            handler: function () {
                this.calculateTotals();
            },
            deep: true
        },
        'invoice.currency': {
            handler: function () {
                this.loadCurrencyRate();
            },
            deep: true
        },
        'invoice.invoice_sequence_id': {
            handler: function () {
                let vm = this;
                this.$API.APICall('get', 'invoice-sequences/' + this.invoice.invoice_sequence_id, {}, (data, success) => {
                    vm.selectedSequenceIsFiskal = (success && data.invoice_sequence !== null && data.invoice_sequence.fiskal);
                }, false);
            },
            deep: true
        },
        'timeOfIssue': {
            handler: function () {
                this.showCurrency = false;
                this.currencyEndpoint = 'select/currencies';
                if (this.timeOfIssue.date + ' ' + this.timeOfIssue.time < this.$store.state.settings.EUR_TRANSITION) {
                    this.currencyEndpoint = 'select/currencies-hrk';
                }
                this.$nextTick(() => {
                    this.invoice.time_of_issue = this.timeOfIssue.date + ' ' + this.timeOfIssue.time;
                    this.showCurrency = true;
                });
            },
            deep: true
        },
        'invoice.time_of_issue': {
            handler: function () {
                this.timeOfIssue.date = this.invoice.time_of_issue.split(' ')[0];
                this.timeOfIssue.time = this.invoice.time_of_issue.split(' ')[1];
                if (this.invoice.time_of_issue > moment().format('YYYY-MM-DD') + ' 23:59:59') {
                    this.invoice.currency = this.$HELPERS.GetDefaultCurrency();
                    this.currencyReadonly = true;
                } else {
                    this.currencyReadonly = false;
                }
                this.loadCurrencyRate();
            },
            deep: true
        }
    },
    methods: {
        /**
         * Fills in the due date from the client's default number of days, which differs for customers that are
         * companies and customers that are persons (or not picked yet).
         */
        setDefaultDueDate() {
            let client = this.$store.state.user.client;
            let days = (this.selectedCustomer != null && this.selectedCustomer.company_id != null)
                ? client.invoice_due_days_company
                : client.invoice_due_days_person;
            this.defaultDueDate = moment().add(days, 'days').format('YYYY-MM-DD');
            this.invoice.due_date = this.defaultDueDate;
        },
        setDocumentFormatFromPaymentMethod() {
            let client = this.$store.state.user.client;
            let field = 'invoice_document_format_id_' + this.invoice.payment_method_id;
            this.invoice.document_format_id = (client[field] !== undefined && client[field] !== null) ? client[field] : 1;
        },
        addCustomerDone(customerId) {
            this.showAddCustomerModal = false;
            if (customerId) {
                this.invoice.customer_id = customerId;
            }
        },
        toggleDetails() {
            this.showDetails = !this.showDetails;
        },
        addPaymentClick() {
            this.editingPayment = null;
            this.showPaymentModal = true;
        },
        editPaymentClick(payment) {
            this.editingPayment = payment;
            this.showPaymentModal = true;
        },
        deletePaymentClick(payment) {
            let vm = this;
            this.$LOCAL_BUS.TriggerEvent('popup', {
                type: 'confirm', text: this.$LANG.Get('alerts.paymentDeletionQuestion'), callback: (response) => {
                    if (response) {
                        vm.$API.APICall('delete', 'payments/' + payment.id, {}, (data, success) => {
                            if (success) {
                                vm.reloadPayments();
                            } else {
                                if (data.message === 'e-reporting failed') {
                                    vm.$LOCAL_BUS.TriggerEvent('popup', {
                                        text: vm.$LANG.Get('alerts.eReportingPaymentFailed'),
                                        type: 'alert'
                                    });
                                } else {
                                    vm.$HELPERS.HandleServerError(vm, data);
                                }
                            }
                        });
                    }
                }
            });
        },
        paymentDone(success) {
            this.showPaymentModal = false;
            if (success) {
                this.reloadPayments();
            }
        },
        eReportingClick(payment) {
            let vm = this;
            vm.$API.APICall('post', 'payments/e-reporting/' + payment.id, {}, (data, success) => {
                if (success) {
                    vm.$LOCAL_BUS.TriggerEvent('popup', {text: vm.$LANG.Get('alerts.eReportingPaymentSuccess'), type: 'alert'});
                    vm.reloadPayments();
                } else {
                    if (data.message === 'e-reporting failed') {
                        vm.$LOCAL_BUS.TriggerEvent('popup', {text: vm.$LANG.Get('alerts.eReportingPaymentFailed'), type: 'alert'});
                    } else {
                        vm.$HELPERS.HandleServerError(vm, data);
                    }
                }
            });
        },
        showDisclaimer(disclaimer) {
            this.$LOCAL_BUS.TriggerEvent('popup', {
                text: disclaimer,
                type: 'alert'
            });
        },
        reloadPayments() {
            let vm = this;
            this.$API.APICall('get', 'invoices/' + this.invoice.id, {}, (data, success) => {
                if (success && data.invoice !== null) {
                    vm.invoice.payments = data.invoice.payments;
                }
            });
        },
        loadCurrencyRate() {
            let vm = this;
            let oldRate = this.invoice.currency_rate;
            let loaded = this.loaded;
            this.$API.APICall('get', 'currencies/' + this.invoice.currency, {date: this.invoice.time_of_issue}, (data, success) => {
                if (success) {
                    if (data.rate != null) {
                        vm.invoice.currency_rate = data.rate;
                        if (loaded) {
                            for (let index in vm.invoice.items) {
                                let item = vm.invoice.items[index];
                                let price = Big(item.price);
                                vm.invoice.items[index]['price'] = ((price * oldRate).toFixed(2) / Big(data.rate)).toFixed(2);
                            }
                        }
                    }
                }
            }, false);
        },
        calculateTotals() {
            this.tempTaxBases = [];
            this.total = Big(0);
            for (let index in this.invoice.items) {
                let item = this.invoice.items[index];
                let total = Big(item.price).times(Big(item.quantity));
                total = Big(total.toFixed(2));
                let item_discount = total.times(Big(item.discount)).div(Big(100));
                item_discount = item_discount.toFixed(2);
                total = total.minus(item_discount);
                total = Big(total.toFixed(2));
                let total_with_discount = total;
                let discount_amount = total_with_discount.times(Big(this.invoice.discount)).div(Big(100));
                discount_amount = Big(discount_amount.toFixed(2));
                total_with_discount = total_with_discount.minus(discount_amount);
                if (this.invoice.tax_system && !this.invoice.ppo) {
                    this.addToTempBase(item.tax, total_with_discount);
                }
                this.invoice.items[index]['total'] = total.toFixed(2);
                this.total = this.total.add(total_with_discount.toFixed(2));
            }
            this.taxBases = JSON.parse(JSON.stringify(this.tempTaxBases));
            if (this.invoice.tax_system && !this.invoice.ppo) {
                this.total = Big(0);
                for (let index in this.taxBases) {
                    let currentBase = this.taxBases[index];
                    let currentTaxAmount = (Big(currentBase.value).times(Big(currentBase.base)).div(Big(100))).toFixed(2);
                    this.total = this.total.add(currentTaxAmount).add(Big(currentBase.value));
                }
            }
        },
        addToTempBase(base, value) {
            let term = false;
            for (let index in this.tempTaxBases) {
                let currentBase = this.tempTaxBases[index];
                if (currentBase.base === base) {
                    term = true;
                    currentBase.value = Big(currentBase.value).add(Big(value)).toString();
                }
            }
            if (!term) {
                this.tempTaxBases.push({
                    base: base,
                    value: Big(value).toString()
                });
            }
        },
        backClick() {
            if (window.history.length === 1) {
                window.close();
            } else {
                this.$router.back();
            }
        },
        buildThingEntries() {
            let entries = [];
            for (let item of this.invoice.items) {
                let count = Math.round(item.quantity);
                if (count < 1) continue;
                let type = null;
                let thingId = null;
                if (item.membership_id) {
                    type = 'membership';
                    thingId = item.membership_id;
                } else if (item.package_id) {
                    type = 'package';
                    thingId = item.package_id;
                } else {
                    continue;
                }
                for (let i = 0; i < count; i++) {
                    entries.push({type: type, thing_id: thingId, name: item.description});
                }
            }
            return entries;
        },
        finishNewInvoice(invoice) {
            let entries = this.buildThingEntries();
            if (entries.length === 0) {
                this.backClick();
                return;
            }
            this.assignThingsModal.invoiceId = invoice.id;
            this.assignThingsModal.entries = entries;
            this.assignThingsModal.defaultPersonId = (this.selectedCustomer && this.selectedCustomer.person_id) ? this.selectedCustomer.person_id : null;
            this.assignThingsModal.show = true;
        },
        assignThingsDone() {
            this.assignThingsModal.show = false;
            this.backClick();
        },
        saveClick() {
            if (this.invoice.customer_id !== this.originalCustomerId) {
                this.saveAction();
            } else {
                if (!this.customerChanged) {
                    this.saveAction();
                } else {
                    let vm = this;
                    this.$LOCAL_BUS.TriggerEvent('popup', {
                        type: 'confirm',
                        text: this.$LANG.Get('alerts.customerChangesQuestionInvoice'),
                        callback: (response) => {
                            if (response) {
                                vm.invoice.customer_data = JSON.parse(JSON.stringify(vm.newCustomerData));
                                vm.customerChanged = false;
                            }
                            vm.saveAction();
                        }
                    });
                }
            }
        },
        saveAction() {
            let success = true;

            if (this.invoice.customer_id == null) {
                success = false;
                this.invoiceValidation.customer_id = this.$LANG.Get('labels.customerIdMissing');
            } else {
                this.invoiceValidation.customer_id = '';
            }

            if (this.originalStatus != this.invoice.invoice_status_id && this.invoice.invoice_status_id > 2) {
                success = false;
                this.invoiceValidation.invoice_status_id = this.$LANG.Get('labels.statusNotAllowed');
            } else {
                this.invoiceValidation.invoice_status_id = '';
            }

            if (this.invoice.due_date == null) {
                success = false;
                this.invoiceValidation.due_date = this.$LANG.Get('labels.dueDateMissing');
            } else {
                this.invoiceValidation.due_date = '';
            }

            if (this.invoice.date_of_delivery == null) {
                success = false;
                this.invoiceValidation.date_of_delivery = this.$LANG.Get('labels.dateOfDeliveryMissing');
            } else {
                this.invoiceValidation.date_of_delivery = '';
            }

            if ((this.invoice.time_of_issue == null) || (!this.$HELPERS.DateTimePattern().test(this.invoice.time_of_issue))) {
                success = false;
                this.timeOfIssueValidation.time = this.$LANG.Get('labels.timeOfIssueMissing');
            } else {
                this.timeOfIssueValidation.time = '';
            }

            let f2_term = this.$HELPERS.CheckF2(this, this.invoice.time_of_issue);

            let itemsValidation = '';
            if (this.invoice.items.length === 0) {
                success = false;
                itemsValidation = this.$LANG.Get('labels.noItems');
            } else {
                itemsValidation = '';
            }
            let termDescription = false;
            let termNegative = false;
            let termKPD = false;
            for (let item of this.invoice.items) {
                if (item.description === '') {
                    termDescription = true;
                }
                if (this.invoice.cancels == 0 && (item.quantity < 0 || item.price < 0)) {
                    termNegative = true;
                }
                if (f2_term === 2 && !this.selectedCustomer.foreign && this.selectedCustomer.company_id !== null && item.code_kpd === '' && this.invoice.payment_method_id == 1) {
                    termKPD = true;
                }
            }
            if (termDescription) {
                if (itemsValidation !== '') {
                    itemsValidation += '\n';
                }
                success = false;
                itemsValidation += this.$LANG.Get('labels.emptyItem');
            }
            if (termNegative) {
                if (itemsValidation !== '') {
                    itemsValidation += '\n';
                }
                success = false;
                itemsValidation += this.$LANG.Get('labels.negativeItem');
            }
            if (termKPD) {
                if (itemsValidation !== '') {
                    itemsValidation += '\n';
                }
                success = false;
                itemsValidation += this.$LANG.Get('labels.KPDRequired');
            }
            this.invoiceValidation.items = itemsValidation;

            let payment_method_term = 1;
            if (f2_term > 0 && this.selectedCustomer != null && this.selectedCustomer.person_id != null) {
                    payment_method_term = 0;
            }
            if (this.invoice.payment_method_id > payment_method_term && !this.selectedSequenceIsFiskal) {
                success = false;
                this.invoiceValidation.payment_method_id = this.$LANG.Get('labels.fiskalNeeded');
            } else {
                this.invoiceValidation.payment_method_id = '';
            }

            if (this.mode == 'add'
                && this.selectedSequenceIsFiskal
                && this.$store.state.user.oib == ''
                && !(this.selectedCustomer.company_id != null
                    && !this.invoice.b2b_transaction_f1_enabled
                    && this.invoice.payment_method_id == 1)
                && !(this.selectedCustomer.company_id != null
                    && this.$store.state.user.client.ignore_b2b_f1)
                )
            {
                success = false;
                this.$LOCAL_BUS.TriggerEvent('popup', {
                    text: this.$LANG.Get('alerts.fiskalUserOibMissing'),
                    type: 'alert'
                });
            }

            if (success) {
                let payload = JSON.parse(JSON.stringify(this.invoice));
                let vm = this;
                let method = 'post';
                let id = null;
                if (this.mode === 'edit') {
                    method = 'put';
                    id = this.invoice.id;
                }
                this.$HELPERS.SubmitInvoice(vm, {
                    method: method,
                    id: id,
                    payload: payload,
                    onSuccess: (savedInvoice) => {
                        vm.$LOCAL_BUS.TriggerEvent('notification', {text: vm.$LANG.Get('alerts.recordSaved')});
                        if (vm.mode === 'add' || vm.mode === 'copy' || vm.mode === 'offer') {
                            vm.finishNewInvoice(savedInvoice);
                        }
                    },
                    onFiskalError: () => {
                        vm.$LOCAL_BUS.TriggerEvent('popup', {
                            text: vm.$LANG.Get('alerts.fiskalError'),
                            type: 'alert'
                        });
                    },
                    onError: (data) => {
                        if (data.error === 'invalid sequence later') {
                            vm.$LOCAL_BUS.TriggerEvent('popup', {
                                text: vm.$LANG.Get('alerts.invoiceSequenceLater'),
                                type: 'alert'
                            });
                        } else if (data.error === 'invalid sequence earlier') {
                            vm.$LOCAL_BUS.TriggerEvent('popup', {
                                text: vm.$LANG.Get('alerts.invoiceSequenceEarlier'),
                                type: 'alert'
                            });
                        } else if (data.error === 'invalid year') {
                            vm.$LOCAL_BUS.TriggerEvent('popup', {
                                text: vm.$LANG.Get('alerts.invoiceInvalidYear'),
                                type: 'alert'
                            });
                        } else if (data.errors !== undefined && data.errors.includes('fiskal certificate is not valid')) {
                            vm.$LOCAL_BUS.TriggerEvent('popup', {
                                text: vm.$LANG.Get('alerts.invoiceInvalidCertificate'),
                                type: 'alert'
                            });
                        } else {
                            let unavailableProducts = [];
                            if (data.errors !== undefined) {
                                for (let error of data.errors) {
                                    let errorData = error.split('|$|');
                                    if (errorData[0] == 'unavailable_supply' && errorData.length > 1) {
                                        unavailableProducts.push(errorData[1]);
                                    }
                                }
                            }
                            if (unavailableProducts.length == 0) {
                                vm.$HELPERS.HandleServerError(vm, data);
                            } else {
                                vm.$LOCAL_BUS.TriggerEvent('popup', {
                                    text: vm.$LANG.Get('alerts.invoiceMissingSupply') + unavailableProducts.join('<br />'),
                                    type: 'alert'
                                });
                            }
                        }
                    }
                });
            }
        },
        addItem() {
            if (this.selectedThing === null) return;
            if (this.selectedThing === -1) {
                let newItem = {
                    description: '',
                    details: '',
                    code_kpd: this.$store.state.user.client.default_kpd_code || '',
                    price: 0,
                    quantity: 1,
                    tax: this.$store.state.settings.DEFAULT_TAX,
                    discount: 0,
                    measurement_unit_id: (this.$store.state.user.client.default_measurement_unit_id !== null) ? this.$store.state.user.client.default_measurement_unit_id : 1,
                    total: 0,
                    product_id: null,
                    membership_id: null,
                    package_id: null
                }
                if (!this.$store.state.user.client.tax_system) newItem.tax = 0;
                this.invoice.items.push(newItem);
                this.$nextTick(() => {
                    this.selectedThing = null;
                });
            } else {
                let vm = this;
                let parts = String(this.selectedThing).split('_');
                let type = parts[0];
                let id = parts[1];
                let defaultMeasurementUnitId = (this.$store.state.user.client.default_measurement_unit_id !== null) ? this.$store.state.user.client.default_measurement_unit_id : 1;
                if (type === 'PRODUCT') {
                    this.$API.APICall('get', 'products/' + id, {}, (data, success) => {
                        if (success) {
                            let newItem = {
                                description: (data.product['name_' + vm.invoice.locale] !== undefined) ? data.product['name_' + vm.invoice.locale] : data.product.name,
                                details: '',
                                code_kpd: data.product.code_kpd,
                                price: data.product.price * this.invoice.currency_rate,
                                quantity: 1,
                                tax: data.product.tax,
                                discount: 0,
                                measurement_unit_id: data.product.measurement_unit_id,
                                total: 0,
                                product_id: data.product.id,
                                membership_id: null,
                                package_id: null
                            }
                            if (this.invoice.time_of_issue < this.$store.state.settings.EUR_TRANSITION) {
                                newItem.price = data.product.price / this.invoice.currency_rate;
                            }
                            vm.invoice.items.push(newItem);
                            vm.selectedThing = null;
                        } else {
                            vm.$HELPERS.HandleServerError(vm, data);
                        }
                    }, false);
                } else if (type === 'MEMBERSHIP') {
                    this.$API.APICall('get', 'memberships/' + id, {}, (data, success) => {
                        if (success) {
                            let newItem = {
                                description: (data.membership['name_' + vm.invoice.locale] !== undefined) ? data.membership['name_' + vm.invoice.locale] : data.membership.name,
                                details: '',
                                code_kpd: data.membership.code_kpd ? data.membership.code_kpd : (this.$store.state.user.client.default_kpd_code || ''),
                                price: data.membership.price * this.invoice.currency_rate,
                                quantity: 1,
                                tax: data.membership.tax,
                                discount: 0,
                                measurement_unit_id: defaultMeasurementUnitId,
                                total: 0,
                                product_id: null,
                                membership_id: data.membership.id,
                                package_id: null
                            }
                            if (this.invoice.time_of_issue < this.$store.state.settings.EUR_TRANSITION) {
                                newItem.price = data.membership.price / this.invoice.currency_rate;
                            }
                            vm.invoice.items.push(newItem);
                            vm.selectedThing = null;
                        } else {
                            vm.$HELPERS.HandleServerError(vm, data);
                        }
                    }, false);
                } else if (type === 'PACKAGE') {
                    this.$API.APICall('get', 'packages/' + id, {}, (data, success) => {
                        if (success) {
                            let newItem = {
                                description: (data.package['name_' + vm.invoice.locale] !== undefined) ? data.package['name_' + vm.invoice.locale] : data.package.name,
                                details: '',
                                code_kpd: data.package.code_kpd ? data.package.code_kpd : (this.$store.state.user.client.default_kpd_code || ''),
                                price: data.package.price * this.invoice.currency_rate,
                                quantity: 1,
                                tax: data.package.tax,
                                discount: 0,
                                measurement_unit_id: defaultMeasurementUnitId,
                                total: 0,
                                product_id: null,
                                membership_id: null,
                                package_id: data.package.id
                            }
                            if (this.invoice.time_of_issue < this.$store.state.settings.EUR_TRANSITION) {
                                newItem.price = data.package.price / this.invoice.currency_rate;
                            }
                            vm.invoice.items.push(newItem);
                            vm.selectedThing = null;
                        } else {
                            vm.$HELPERS.HandleServerError(vm, data);
                        }
                    }, false);
                }
            }
        },
        removeItemClick(index) {
            let vm = this;
            this.$LOCAL_BUS.TriggerEvent('popup', {
                type: 'confirm', text: this.$LANG.Get('alerts.generalRemovalQuestion'), callback: (response) => {
                    if (response) {
                        vm.invoice.items.splice(index, 1);
                    }
                }
            });
        },
        changeKPDClick(index) {
            this.kpdPopup.indexToEdit = index;
            this.kpdPopup.data.code_kpd = this.invoice.items[index].code_kpd;
            if (this.kpdPopup.data.code_kpd === '') this.kpdPopup.data.code_kpd = null;
            this.kpdPopup.show = true;
        }
    },
    mounted() {

        this.$store.commit('selectMenu', 'finance');
        this.$store.commit('selectSubMenu', 'invoices');

        if (this.$store.state.user.invoice_sequences_count === 0) {
            this.$LOCAL_BUS.TriggerEvent('popup', {text: this.$LANG.Get('alerts.noActiveInvoiceSequences'), type: 'alert'});
            this.$router.push('/financial-settings');
        } else {
            this.sequences = this.$store.state.user.invoice_sequences;
            if (this.sequences.length > 0) {
                this.invoice.invoice_sequence_id = this.$store.state.user.default_invoice_sequence_id;
            } else {
                this.$LOCAL_BUS.TriggerEvent('popup', {text: this.$LANG.Get('alerts.unauthorized'), type: 'alert'});
                this.$router.push('/');
            }
        }

        if (this.mode === 'add') {
            this.$store.commit('setBreadcrumbs', [
                {
                    label: this.$LANG.Get('modules.finance'),
                    link: null
                },
                {
                    label: this.$LANG.Get('modules.invoices'),
                    link: '/invoices'
                },
                {
                    label: this.$LANG.Get('modules.newInvoice'),
                    link: null
                }
            ]);

            // A customer handed over in the URL ("Save and create new invoice" on a new person) wins over the
            // client's default customer.
            let presetCustomerId = parseInt(this.$route.query.customer_id);
            this.invoice.customer_id = isNaN(presetCustomerId)
                ? this.$store.state.user.client.invoice_default_customer_id
                : presetCustomerId;
            this.invoice.tax_system = this.$store.state.user.client.tax_system;
            this.invoice.time_of_issue = moment().format('YYYY-MM-DD HH:mm:ss');
            this.invoice.date_of_delivery = moment().format('YYYY-MM-DD');
            this.setDefaultDueDate();
            this.invoice.footer = this.$store.state.user.client['invoice_footer_template_' + this.$store.state.locale];
            this.invoice.locale = this.$store.state.locale;
            this.invoice.payment_method_id = this.$store.state.user.client.default_payment_method_id
                ? this.$store.state.user.client.default_payment_method_id : 1;
            this.setDocumentFormatFromPaymentMethod();

            this.$nextTick(() => {
                this.loaded = true;
            });
        } else if (this.mode === 'edit') {
            let vm = this;
            this.$API.APICall('get', 'invoices/' + this.invoice.id, {}, (data, success) => {
                if (success) {
                    if (data.invoice !== null) {
                        if ((data.invoice.is_using_wares) || (data.invoice.cancels !== 0) || (data.invoice.cancelled_by !== 0) || (data.invoice.zki !== '')) {
                            vm.readonlyAll = true;
                        }
                        // Imported invoices are fully read-only.
                        if (data.invoice.imported) {
                            vm.readonlyAll = true;
                            vm.imported = true;
                        }
                        if ((data.invoice.e_invoice_id != null) || (data.invoice.e_reporting_id != null)) {
                            vm.readonlyVat = true;
                        }
                        vm.invoice.Fill(data.invoice);
                        vm.showDetails = vm.invoice.items.some(item => item.details && item.details !== '');
                        vm.originalStatus = data.invoice.invoice_status_id;
                        vm.customerChanged = data.invoice.customer_changed;
                        vm.originalCustomerId = data.invoice.customer_id;
                        vm.newCustomerData = data.invoice.new_customer_data;
                        let breadcrumb = vm.invoice.number;
                        if (vm.invoice.e_invoice_id != null) breadcrumb += ' (E)';
                        vm.$store.commit('setBreadcrumbs', [
                            {
                                label: vm.$LANG.Get('modules.finance'),
                                link: null
                            },
                            {
                                label: vm.$LANG.Get('modules.invoices'),
                                link: '/invoices'
                            },
                            {
                                label: breadcrumb,
                                link: null
                            }
                        ]);
                    } else {
                        vm.$HELPERS.HandleServerError(vm, data);
                    }
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
                vm.$nextTick(() => {
                    vm.loaded = true;
                });
            });
        } else if (this.mode === 'copy') {
            let vm = this;
            this.$API.APICall('get', 'invoices/' + this.invoice.id, {}, (data, success) => {
                if (success) {
                    vm.invoice.id = 0;
                    vm.invoice.time_of_issue = moment().format('YYYY-MM-DD HH:mm:ss');
                    vm.setDefaultDueDate();
                    vm.invoice.date_of_delivery = moment().format('YYYY-MM-DD');
                    vm.invoice.customer_id = data.invoice.customer_id;
                    vm.invoice.currency = data.invoice.currency;
                    if (vm.invoice.time_of_issue >= this.$store.state.settings.EUR_TRANSITION && vm.invoice.currency === 'HRK') {
                        vm.invoice.currency = 'EUR';
                    }
                    let items = JSON.parse(JSON.stringify(data.invoice.items));
                    for (let i = 0; i < items.length; i++) {
                        items[i].id = undefined;
                    }
                    vm.invoice.items = items;
                    vm.showDetails = vm.invoice.items.some(item => item.details && item.details !== '');
                    vm.invoice.payment_method_id = data.invoice.payment_method_id;
                    vm.invoice.ppo = data.invoice.ppo;
                    vm.invoice.ppo_text = data.invoice.ppo_text;
                    vm.invoice.discount = data.invoice.discount;
                    vm.invoice.footer = data.invoice.footer;
                    vm.invoice.tax_system = vm.$store.state.user.client.tax_system;
                    vm.invoice.locale = data.invoice.locale;
                    vm.invoice.payment_method_id = data.invoice.payment_method_id;
                    vm.setDocumentFormatFromPaymentMethod();

                    this.$store.commit('setBreadcrumbs', [
                        {
                            label: this.$LANG.Get('modules.finance'),
                            link: null
                        },
                        {
                            label: this.$LANG.Get('modules.invoices'),
                            link: '/invoices'
                        },
                        {
                            label: this.$LANG.Get('modules.newInvoice'),
                            link: null
                        }
                    ]);
                    vm.$nextTick(() => {
                        vm.loaded = true;
                    });
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        } else if (this.mode === 'offer') {
            let vm = this;
            this.$API.APICall('get', 'offers/' + this.invoice.id, {}, (data, success) => {
                if (success) {
                    vm.offerNumber = data.offer.number;

                    let tempData = JSON.parse(JSON.stringify(data.offer));
                    tempData.id = 0;
                    tempData.imported = false;
                    tempData.offer_id = parseInt(vm.$route.params.id);
                    tempData.tax_system = vm.$store.state.user.client.tax_system;
                    tempData.payment_method_id = vm.$store.state.user.client.default_payment_method_id
                        ? vm.$store.state.user.client.default_payment_method_id : 1;
                    tempData.invoice_sequence_id = vm.$store.state.user.default_invoice_sequence_id;

                    tempData.time_of_issue = moment().format('YYYY-MM-DD HH:mm:ss');
                    tempData.date_of_delivery = moment().format('YYYY-MM-DD');

                    tempData.customer_changed = false;
                    tempData.locale = data.offer.locale;

                    tempData.footer = vm.$store.state.user.client['invoice_footer_template_' + tempData.locale] + "\n" + vm.$LANG.Get('texts.invoiceForOffer_' + tempData.locale).replace('%offer%', vm.offerNumber);

                    for (let index in tempData.items) {
                        tempData.items[index].id = undefined;
                    }

                    if (tempData.time_of_issue >= this.$store.state.settings.EUR_TRANSITION && tempData.currency === 'HRK') {
                        tempData.currency = 'EUR';
                    }

                    vm.invoice.Fill(tempData);
                    vm.setDefaultDueDate();
                    vm.setDocumentFormatFromPaymentMethod();
                    vm.showDetails = tempData.items.some(item => item.details && item.details !== '');

                    vm.$store.commit('setBreadcrumbs', [
                        {
                            label: this.$LANG.Get('modules.finance'),
                            link: null
                        },
                        {
                            label: this.$LANG.Get('modules.invoices'),
                            link: '/invoices'
                        },
                        {
                            label: this.$LANG.Get('modules.invoiceFromOffer') + ' ' + vm.offerNumber,
                            link: null
                        }
                    ]);
                    vm.$nextTick(() => {
                        vm.loaded = true;
                    });
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        }
    }
}
</script>

<style scoped>
.invoice-tabs {
    margin-top: 18px;
    margin-bottom: 6px;
}

.form {
    max-width: 300px;
    margin-bottom: 10px;
}

.form-float {
    width: 300px;
    float: left;
    margin-right: 10px;
    margin-bottom: 10px;
    padding: 15px;
}

.form-float h2 {
    margin: 0 0 5px;
}

.customer-details {
    margin: 5px;
}

.items-card {
    clear: both;
}

.details-button {
    float: right;
    margin-bottom: 5px;
}

.items-container {
    clear: both;
    overflow-x: auto;
    white-space: nowrap;
}

.footer-container {
    margin-top: 10px;
    width: calc(100% - 20px);
}

.item-select {
    max-width: 500px;
}

.items-table {
    width: 100%;
    min-width: 1000px;
}

.items-table-header td {
    font-size: 12px;
    padding-left: 5px;
}

.items-table td {
    vertical-align: top;
}

.items-table-buttons {
    text-align: center;
}

.items-table-buttons span {
    cursor: pointer;
}

/* Match the button box to the field input (same 13px vertical padding) and offset it by the
   field wrapper's 5px top padding, so the buttons line up with the first row of inputs. */
.items-table-buttons .nevs-button,
.items-table-kpd .nevs-button {
    padding: 13px;
    margin-top: 5px;
}

.summary-table {
    float: right;
    margin-top: 30px;
    width: 400px;
}

.payments-tab-disclaimer {
    margin: 10px 0;
    color: #888;
    font-style: italic;
}

.payments {
    width: calc(100% - 20px);
    max-width: 400px;
}

.payments-list {
    margin-bottom: 10px;
}

.payments table {
    width: 100%;
}

.payment {
    border-bottom: 1px solid #c6d8e2;
}

.nevs-popup {
    max-width: 300px;
}

.payment-date {
    padding: 5px;
}

.payment-amount {
    padding: 5px;
}

.payment-actions {
    text-align: right;
    white-space: nowrap;
}

.payment-actions .nevs-button:not(:last-child) {
    margin-right: 5px;
}

.e-status-pill {
    text-align: center;
    display: inline-block;
    background-color: #adbd21;
    padding: 5px;
    border-radius: 5px;
}

.invoice-disclaimer-button {
    margin-right: 3px;
}

.number-status-pill {
    display: inline-block;
    padding: 5px;
    border-radius: 5px;
    margin-right: 5px;
}

.number-status-pill.imported-pill {
    background-color: #d32f2f;
    color: white;
    font-weight: bold;
}

.f1-checkbox {
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid #c6d8e2;
}

.f1-notice {
    padding: 5px;
    color: red;
}

.bank-field {
    max-width: 400px;
}

@media only screen and (max-width: 500px) {
    .summary-table {
        float: none;
    }
}

</style>